import { render } from "./answerDetails.vue?vue&type=template&id=27ef2198&scoped=true"
import script from "./answerDetails.vue?vue&type=script&lang=js"
export * from "./answerDetails.vue?vue&type=script&lang=js"

import "./answerDetails.vue?vue&type=style&index=0&id=27ef2198&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ef2198"]])

export default __exports__